import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { langSelectOptions } from '../../lib/preLoginLang';
import { AdminFunctions, AdminTypes, AdminPosition } from '../../config/RayCodes';
import { AlertAction, AdminUserAction, CompanyAction } from '../../actions';
import { RayForm, RayFormValidation } from '../../components/common';
import { history } from '../../history';
import { Loading } from '../../components/common/Loading';
import { Translate as t } from '../../config/Translate';
import { localizeUserFormErrors } from '../../lib/userFormErrors';
import { ORG_HQ } from '../../config/appConstants';
import { getCallerTier, isFieldEditableByTier } from '../../lib/userPermissionGuard';
import { userFieldLabel, dealerTypeOptions } from './userFormFields';

const AdminUserAdd = ({ companyList, RegistUserInfo, ClearUpdateResult, apierrors, isUpdateRes }) => {
    const [errors, setErrors] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [valid, setValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [user, setUser] = useState({
        isUse: true,
        adminType: AdminTypes[2].code,
        function: AdminFunctions[0].code,
        language: "eng",
        rguardSettingLanguage: "eng",
        rguardSettingEmailReportLanguage: "eng",
        position: AdminPosition[0].code,
        password: "ray12345",
        passwordConfirm: "ray12345",
        isEmail: true,
        // FEAT-025 SPEC-RG-03 — 신규 필드. default 'internal' 로 하위 호환 유지.
        dealerType: 'internal',
        // SEC-083 (#484) — 생성 화면에 항목이 없어 전원 관리자 접근 권한을 갖던 결함. default false.
        permAdminAccess: false,
        isCreateLicense: false,
        isSetWarranty: false,
    });

    const [currentUserInfo, setCurrentUserInfo] = useState({});

    // 권한 스위치는 수정 화면과 같은 판정을 쓴다. S 가 아니거나, 본사가 아닌 S 가 대상 회사를 고르기 전이면
    // 잠겨서 서버 안전 기본값(CREATE_SAFE_SWITCH_DEFAULTS)만 보낸다. 본사 S 는 처음부터 풀려 있다.
    const accessibleCompanyIds = (Array.isArray(companyList) ? companyList : []).map(c => c?.companyId);
    const callerTier = getCallerTier(currentUserInfo, { companyId: user.companyId }, accessibleCompanyIds);
    const lockBadgeFor = (name) => (isFieldEditableByTier(name, callerTier) ? '' : ' 🔒');
    const switchLocked = (name) => !isFieldEditableByTier(name, callerTier);

    const [csLink, setCsLink] = useState("");

    useEffect(() => {
        setCurrentUserInfo(JSON.parse(localStorage.getItem('user')));
    }, []);

    const setCompanySelect = () => {
        const cList = [];
        companyList.map((c) => cList.push({ code: c.companyId, title: c.name }));
        setCompanies(cList);
        setUser({ ...user, companyId: cList[0].code });
    }

    const form_controls = [
        {
            title: "", items: [
                { type: "input", name: "adminid", label: t('user.field.adminId'), val: user.adminid, required: true },
                { type: "select2", name: "companyId", label: t('common.label.company'), val: user.companyId, list: companies, required: true },
            ]
        },
        {
            title: "", items: [
                { type: "password", name: "password", label: t('common.field.password'), val: "ray12345", required: true },
                { type: "password", name: "passwordConfirm", label: t('auth.field.passwordConfirm'), val: "ray12345", required: true },
            ]
        },
        {
            title: "", items: [
                {
                    type: "select",
                    name: "adminType",
                    label: userFieldLabel('adminType'),
                    val: user.adminType,
                    list: AdminTypes.filter(x => {
                        return currentUserInfo.adminType == 'S' && (x.code == 'S' || x.code == 'M' || x.code == 'U') ||
                            currentUserInfo.adminType == 'M' && (x.code == 'M' || x.code == 'U') ||
                            currentUserInfo.adminType == 'U' && x.code == 'U'
                    }),
                    required: true
                },
                { type: "select", name: "function", label: userFieldLabel('function'), val: user.function, list: AdminFunctions, required: true },
                { type: "select", name: "position", label: t('common.field.position'), val: user.position, list: AdminPosition, required: true },
                // SEC-083 (#484) — Admin Access 입력 항목 신설.
                { type: "checkbox", name: "permAdminAccess", label: `${userFieldLabel('permAdminAccess')}${lockBadgeFor('permAdminAccess')}`, size: 12, val: user.permAdminAccess, locked: switchLocked('permAdminAccess') },
            ]
        },
        {
            title: "", items: [
                {
                    type: "select",
                    name: "dealerType",
                    label: `${userFieldLabel('dealerType')}${lockBadgeFor('dealerType')}`,
                    val: user.dealerType,
                    list: dealerTypeOptions(),
                    required: true,
                    locked: switchLocked('dealerType'),
                },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "firstName", label: t('common.field.firstName'), val: user.firstName, required: true },
                { type: "input", name: "lastName", label: t('common.field.lastName'), val: user.lastName, required: true },
            ]
        },
        {
            title: "", items: [
                { type: "email", name: "email", label: t('common.field.email'), val: user.email, required: true },
                { type: "select", name: "rguardSettingLanguage", label: userFieldLabel('rguardSettingLanguage'), val: user.rguardSettingLanguage, list: langSelectOptions(user.rguardSettingLanguage), required: true },
                { type: "select", name: "rguardSettingEmailReportLanguage", label: userFieldLabel('rguardSettingEmailReportLanguage'), val: user.rguardSettingEmailReportLanguage, list: langSelectOptions(user.rguardSettingEmailReportLanguage), required: true },
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "hp", label: t('common.field.mobile'), val: user.hp },
                { type: "tel", name: "tel", label: t('common.field.tel'), val: user.tel },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "csPortalLink", label: userFieldLabel('csPortalLink'), size: 12, val: csLink },
            ]
        },
        {
            title: "", items: [
                { type: "checkbox", name: "isEmail", label: userFieldLabel('isEmail'), val: user.isEmail },
                { type: "checkbox", name: "isUse", label: `${userFieldLabel('isUse')}${lockBadgeFor('isUse')}`, val: user.isUse, locked: switchLocked('isUse') },
                { type: "checkbox", name: "isCreateLicense", label: `${userFieldLabel('isCreateLicense')}${lockBadgeFor('isCreateLicense')}`, val: user.isCreateLicense, locked: switchLocked('isCreateLicense') },
                { type: "checkbox", name: "isSetWarranty", label: `${userFieldLabel('isSetWarranty')}${lockBadgeFor('isSetWarranty')}`, val: user.isSetWarranty, locked: switchLocked('isSetWarranty') },
            ]
        }
    ]

    useEffect(() => {
        //GetCompany();
    }, []);

    useEffect(() => {
        if (companyList.length > 0)
            setCompanySelect();
    }, [companyList]);

    useEffect(() => {
        // IMP-468 (#507): 서버가 보낸 필드 에러 문구는 단일 언어 하드코딩이라 로케일을 따르지 않는다.
        setErrors(localizeUserFormErrors(apierrors));
    }, [apierrors]);

    useEffect(() => {
        if (isUpdateRes) {
            setIsLoading(false);
            ClearUpdateResult();
            history.push("/Admin/AdminUserList");
        }
    }, [isUpdateRes]);

    useEffect(() => {
        const errValidate = RayFormValidation(form_controls, user);
        if (errValidate.length == 0) {
            setValid(true);
        } else {
            setValid(false);
        }
    }, [user])

    const handleChangeData = (e) => {
        const { name, value } = e.target;
        if (name == "companyId") {
            const orgType = companyList.filter(x => x.companyId == value)[0].org;
            // PR #211 review (Blocker) — 기존 `||` 는 항상 true (orgType 은 'Branch'와 'HQ' 둘 다일 수 없음).
            // 의도: orgType 이 Branch/HQ 둘 다 아닐 때 partner 첫 링크 사용 → `&&` 로 정정.
            if (orgType != "Branch" && orgType != ORG_HQ) {
                setCsLink("https://partner.raymedical.com/?autologin_code=IKMqLobcisfFYxvQge6rzEGo1DZfLJ");
                setUser({ ...user, ["csPortalLink"]: "https://partner.raymedical.com/?autologin_code=IKMqLobcisfFYxvQge6rzEGo1DZfLJ" });
            } else {
                setCsLink("https://partner.raymedical.com/?autologin_code=hkggy1y3eLES9kmAYMhiQBjoWdHGta");
                setUser({ ...user, ["csPortalLink"]: "https://partner.raymedical.com/?autologin_code=hkggy1y3eLES9kmAYMhiQBjoWdHGta" });
            }
        }

        if (name == "csPortalLink") {
            setCsLink(value);
        }

        setUser({ ...user, [name]: value });
    };

    const handleRegist = (e) => {
        setIsLoading(true);
        const errValidate = RayFormValidation(form_controls, user);
        if (errValidate.length > 0) {
            setErrors(errValidate);
            setIsLoading(false);
        } else {
            if (user.password == user.passwordConfirm) {
                // SEC-083 (#484) — 체크박스 값이 문자열 경로로 들어와도 payload 는 boolean 으로 고정.
                // language 는 시스템 언어와 같은 값으로 함께 보낸다(옛 경로 하위 호환).
                RegistUserInfo({ ...user, language: user.rguardSettingLanguage, permAdminAccess: Boolean(user.permAdminAccess) });
            } else {
                setErrors([{ name: "passwordConfirm", msg: t('auth.message.error.checkPassword') }]);
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            <div className="extraHeader">
                <h2 className="mb-0">{t('user.button.add')}</h2>
                <div className="ray-right">
                    {/* PR #185 R2 — Back 링크가 /Admin/CompanyList 로 잘못 박혀 있던 기존 버그 수정. List 로 복귀. */}
                    <Link className="btn btn-outline-default m-l-5" to="/Admin/AdminUserList">{t('common.button.back')}</Link>
                </div>
            </div>
            <div id="appCapsule" className="extra-header-active full-height">
                <div className="section mt-1 mb-1">
                    <RayForm
                        controls={form_controls}
                        isForm={true}
                        handleChangeData={handleChangeData}
                        errors={errors} />
                    {isLoading && <Loading />} 
                    {!isLoading && <button className={`btn btn-outline-primary ms-2 me-2 ${!valid ? "disabled" : ""}`} onClick={handleRegist}>{t('user.button.add')}</button>}
                </div>
            </div>
        </>
    );
};

const mapState = (state) => {
    const isUpdateRes = state.AdminUserReducer.isUpdateRes;
    const companyList = state.CompanyReducer.companies;
    const apierrors = state.AlertReducer.errors;

    return { companyList, isUpdateRes, apierrors };
}

const mapDispatch = dispatch => ({
    RegistUserInfo: (userinfo) => dispatch(AdminUserAction.RegistUserInfo(userinfo)),
    ResultSuccess: (msg) => dispatch(AlertAction.Success(msg)),
    ResultError: (msg) => dispatch(AlertAction.Error(msg)),
    //GetCompany: () => dispatch(CompanyAction.GetCompany()),
    ClearUpdateResult: () => dispatch(AdminUserAction.ClearUpdateResult())
})

export default connect(mapState, mapDispatch)(AdminUserAdd);